import { LockOutlined } from "@ant-design/icons";
import { Form, Input } from "antd";
import { isMaskedValue } from "common/Utility";
import EmailVerificationBadge from "components/atoms/EmailVerificationBadge";
import validator from "validator";
import SchemaFieldTitle from "../SchemaFieldTitle";
import Tooltip from "../Tooltip";

function FormEmailField({ fieldErrors, fieldId, name, description, max, min, isRequired, isPrimaryKey, disabled = false, ...field }) {
    const fieldValue = Form.useWatch([fieldId]);
    const isMasked = isMaskedValue(fieldValue);
    const isDisabled = disabled || (field.isPII && isMasked);

    return (
        <Form.Item
            key={fieldId}
            name={[fieldId]}
            label={
                <div style={{ display: "flex", alignItems: "center" }}>
                    <SchemaFieldTitle name={name} tags={field.classifiers} orientation="horizontal" tagSummary={false} isPrimaryKey={field.isPrimaryKey} />
                    {field.isPII && (
                        <Tooltip title="Masked data due to PII restriction">
                            <LockOutlined style={{ marginLeft: 8, color: "#1890ff" }} />
                        </Tooltip>
                    )}
                    <EmailVerificationBadge verificationResult={field.verificationResult} />
                </div>
            }
            tooltip={description}
            validateFirst={true}
            rules={[
                {
                    required: isRequired,
                    message: `Value is required`,
                },
                {
                    validator(_, value) {
                        if (value && value.toString().trim()) {
                            if (validator.isEmail(value)) {
                                return Promise.resolve();
                            }
                            return Promise.reject(`Value should be a valid email`);
                        }
                        return Promise.resolve();
                    },
                },
                {
                    type: "string",
                    min: min,
                    message: `Value should be minimum ${min} characters long`,
                },
                {
                    type: "string",
                    max: max,
                    message: `Value should be maximum ${max} characters long`,
                },
            ]}
            {...fieldErrors}
        >
            <Input disabled={isDisabled} placeholder={isMasked ? "Masked PII - Use 'Reveal' to edit" : undefined} />
        </Form.Item>
    );
}

export default FormEmailField;
